/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Transcript_Export_Preset_SavedInputs */

const en_transcript_export_preset_saved = /** @type {(inputs: Transcript_Export_Preset_SavedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Preset "${i?.name}" saved successfully`)
};

const fr_transcript_export_preset_saved = /** @type {(inputs: Transcript_Export_Preset_SavedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Prereglage "${i?.name}" enregistre avec succes`)
};

const de_transcript_export_preset_saved = /** @type {(inputs: Transcript_Export_Preset_SavedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Voreinstellung "${i?.name}" erfolgreich gespeichert`)
};

const it_transcript_export_preset_saved = /** @type {(inputs: Transcript_Export_Preset_SavedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Preimpostazione "${i?.name}" salvata correttamente`)
};

const ru_transcript_export_preset_saved = /** @type {(inputs: Transcript_Export_Preset_SavedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Предварительные настройки "${i?.name}" успешно сохранены.`)
};

const es_transcript_export_preset_saved = /** @type {(inputs: Transcript_Export_Preset_SavedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`El ajuste preestablecido "${i?.name}" se guardó correctamente`)
};

const zh_cn2_transcript_export_preset_saved = /** @type {(inputs: Transcript_Export_Preset_SavedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`预设“${i?.name}”已成功保存`)
};

const ja_transcript_export_preset_saved = /** @type {(inputs: Transcript_Export_Preset_SavedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`プリセット「${i?.name}」が正常に保存されました`)
};

const hi_transcript_export_preset_saved = /** @type {(inputs: Transcript_Export_Preset_SavedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`प्रीसेट "${i?.name}" सफलतापूर्वक सहेज लिया गया`)
};

const pt_pt2_transcript_export_preset_saved = /** @type {(inputs: Transcript_Export_Preset_SavedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Predefinição "${i?.name}" salva com sucesso`)
};

/**
* | output |
* | --- |
* | "Preset \"{name}\" saved successfully" |
*
* @param {Transcript_Export_Preset_SavedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_preset_saved = /** @type {((inputs: Transcript_Export_Preset_SavedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Preset_SavedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_transcript_export_preset_saved(inputs)
	if (locale === "de") return de_transcript_export_preset_saved(inputs)
	if (locale === "it") return it_transcript_export_preset_saved(inputs)
	if (locale === "ru") return ru_transcript_export_preset_saved(inputs)
	if (locale === "es") return es_transcript_export_preset_saved(inputs)
	if (locale === "zh-CN") return zh_cn2_transcript_export_preset_saved(inputs)
	if (locale === "ja") return ja_transcript_export_preset_saved(inputs)
	if (locale === "hi") return hi_transcript_export_preset_saved(inputs)
	if (locale === "pt-PT") return pt_pt2_transcript_export_preset_saved(inputs)
	return en_transcript_export_preset_saved(inputs)
});